import { formatExact, type UnitDefinition } from '@wms/shared';
import type { ProductUnitBrief } from './types';

/**
 * 【用户需求】数量以"箱 + 余"混合显示："3144 支"→"131 箱"、"561 支"→
 * "23 箱 + 9 支"。余数由 shared 的 decompose 保证规范化（余 ≥ 每箱数必然
 * 进位，一箱 3 支时永远不会出现"余 9"）。无包装单位（只有基本单位）时
 * 退化为原样"3144 支"；units 缺失（旧缓存/旧响应）时回退 baseQty + 兜底
 * 单位码，绝不因显示层换算抛错。
 */
export function formatQty(
  baseQty: string,
  units: readonly ProductUnitBrief[] | undefined,
  fallbackUnitCode?: string,
): string {
  const fallback = fallbackUnitCode ? `${baseQty} ${fallbackUnitCode}` : baseQty;
  if (!units || units.length === 0) return fallback;
  try {
    const defs: UnitDefinition[] = units.map((u) => ({
      id: u.uomCode,
      code: u.uomCode,
      factorToBase: BigInt(u.factorToBase),
      isBase: u.isBase,
    }));
    return formatExact(BigInt(baseQty), defs, (u) => u.code);
  } catch {
    return fallback;
  }
}
